import { render, staticRenderFns } from "./designer-avg-table.vue?vue&type=template&id=6f01312a&scoped=true"
import script from "./designer-avg-table.vue?vue&type=script&lang=js"
export * from "./designer-avg-table.vue?vue&type=script&lang=js"
import style0 from "./designer-avg-table.vue?vue&type=style&index=0&id=6f01312a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f01312a",
  null
  
)

export default component.exports